(() => {
  const root = document.querySelector('[data-fs-signup-launcher]');
  if (!root || root.dataset.initialized) return;
  // Share the native teaser's stacking context, outside the sticky header.
  document.body.appendChild(root);
  root.dataset.initialized = 'true';
  const trigger = root.querySelector('[data-fs-free-kit-trigger]');
  const dismiss = root.querySelector('[data-fs-signup-dismiss]');
  const storageKey = 'flowstate:free-kit-dismissed:v1';
  try { root.hidden = sessionStorage.getItem(storageKey) === '1'; } catch { root.hidden = false; }
  dismiss.addEventListener('click', () => {
    root.hidden = true;
    try { sessionStorage.setItem(storageKey, '1'); } catch {}
  });
  trigger.addEventListener('click', event => {
    if (!document.querySelector('script[src*="klaviyo"]')) return;
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    if (typeof window._klOnsite.openForm === 'function') window._klOnsite.openForm('WaVGtK');
    else window._klOnsite.push(['openForm', 'WaVGtK']);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const form = document.querySelector('[data-testid="klaviyo-form-WaVGtK"]');
    if (!form || !form.getBoundingClientRect().width) return;
    const close = form.closest('[data-testid="modal-form-container"]')?.querySelector('.klaviyo-close-form');
    if (close) {
      event.preventDefault();
      close.click();
    }
  });
  // Lift the invitation above mobile purchase actions without hiding it.
  if ('IntersectionObserver' in window) {
    const visible = new Set();
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      }
      root.toggleAttribute('data-purchase-visible', visible.size > 0);
    }, { rootMargin: '12px', threshold: 0 });
    const observe = scope => scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"],button[name="add"],.shopify-payment-button').forEach(button => observer.observe(button));
    observe(document);
    document.addEventListener('shopify:section:load', event => observe(event.target));
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
    window.addEventListener('pageshow', event => { if (event.persisted) observe(document); });
  }
})();
